( function () {
	'use strict';

	var storageKey = 'folis_consent';
	var legacyStorageKey = 'twentytwentyfive_child_consent';
	var banner = document.querySelector( '[data-cookie-consent]' );

	if ( ! banner ) {
		return;
	}

	var form = banner.querySelector( '[data-cookie-consent-form]' );
	var analytics = form.elements.analytics;
	var marketing = form.elements.marketing;

	function getPreference() {
		try {
			return JSON.parse( window.localStorage.getItem( storageKey ) || window.localStorage.getItem( legacyStorageKey ) );
		} catch ( error ) {
			return null;
		}
	}

	function loadClarity() {
		// Starts Microsoft Clarity ourselves, only once analytics consent is
		// granted. The Clarity plugin's own "Consent Mode" setting withholds
		// cookies but still lets the recorder run and send its /collect
		// beacons, so the tag must never be requested at all before consent
		// exists -- see folis_remove_unconditional_clarity_tag() in
		// functions.php, which strips the plugin's own unconditional snippet.
		var projectId = window.folisClarityConfig && window.folisClarityConfig.projectId;

		if ( ! projectId || window.clarity ) {
			return;
		}

		( function ( c, l, a, r, i, t, y ) {
			c[ a ] = c[ a ] || function () {
				( c[ a ].q = c[ a ].q || [] ).push( arguments );
			};
			t = l.createElement( r );
			t.async = 1;
			t.src = 'https://www.clarity.ms/tag/' + i;
			y = l.getElementsByTagName( r )[ 0 ];
			y.parentNode.insertBefore( t, y );
		}( window, document, 'clarity', 'script', projectId ) );
	}

	function updateConsent( preference ) {
		if ( 'function' === typeof window.wp_set_consent ) {
			window.wp_set_consent( 'statistics', preference.analytics ? 'allow' : 'deny' );
			window.wp_set_consent( 'marketing', preference.marketing ? 'allow' : 'deny' );
		} else if ( 'function' === typeof window.gtag ) {
			window.gtag( 'consent', 'update', {
				ad_storage: preference.marketing ? 'granted' : 'denied',
				analytics_storage: preference.analytics ? 'granted' : 'denied',
				ad_user_data: preference.marketing ? 'granted' : 'denied',
				ad_personalization: preference.marketing ? 'granted' : 'denied',
				functionality_storage: 'denied',
				personalization_storage: 'denied',
				security_storage: 'granted'
			} );
		}

		if ( preference.analytics ) {
			loadClarity();
		} else if ( 'function' === typeof window.clarity ) {
			// Best-effort: if consent is withdrawn after Clarity already loaded
			// this session, tell it to stop recording and drop its own cookies.
			window.clarity( 'consent', false );
		}
	}

	function savePreference( preference ) {
		try {
			window.localStorage.setItem( storageKey, JSON.stringify( preference ) );
		} catch ( error ) {
			// Consent remains effective for this page even if local storage is unavailable.
		}

		updateConsent( preference );
		banner.hidden = true;
	}

	var preference = getPreference();

	if ( preference && 1 === preference.version ) {
		analytics.checked = Boolean( preference.analytics );
		marketing.checked = Boolean( preference.marketing );
		updateConsent( preference );
		banner.hidden = true;
	} else {
		analytics.checked = false;
		marketing.checked = false;
		banner.hidden = false;
	}

	form.addEventListener( 'submit', function ( event ) {
		event.preventDefault();
		savePreference( {
			version: 1,
			analytics: analytics.checked,
			marketing: marketing.checked
		} );
	} );

	banner.querySelector( '[data-cookie-consent-accept]' ).addEventListener( 'click', function () {
		analytics.checked = true;
		marketing.checked = true;
		savePreference( {
			version: 1,
			analytics: true,
			marketing: true
		} );
	} );

	banner.querySelector( '[data-cookie-consent-reject]' ).addEventListener( 'click', function () {
		analytics.checked = false;
		marketing.checked = false;
		savePreference( {
			version: 1,
			analytics: false,
			marketing: false
		} );
	} );

	var manageButton = document.querySelector( '[data-cookie-consent-manage]' );

	if ( manageButton ) {
		manageButton.addEventListener( 'click', function () {
			banner.hidden = false;
			analytics.focus();
		} );
	}
}() );
